import { atom } from 'recoil';

// Auth token is now an httpOnly cookie set by the server — JS cannot read it.
// We use the presence of 'userData' in localStorage as the login marker so the
// UI knows to show the authenticated view on reload. The actual session is
// validated server-side on every API call via the httpOnly cookie.
const authAtom = atom({
    key: 'token',
    default: localStorage.getItem('userData') ? 'authenticated' : '',
});

export { authAtom };